import { languageGlobal } from "./GlobalVariableConfig";

export const getManifestMobile = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    {
                        alias: 'bannerBG',
                        src: 'assets/mobile/1_loading/loading_bg.webp',
                    },
                    {
                        alias: 'introBG',
                        src: 'assets/mobile/2_intro/introduction_bg.webp',
                    },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/mobile/2_intro/volatility_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/mobile/2_intro/volatility_off.webp',
                    },
                    // {
                    //     alias: 'ticketBase',
                    //     src: 'assets/mobile/2_intro/ticket.webp',
                    // },
                    {
                        alias: 'image1',
                        src: 'assets/mobile/2_intro/image_1.png',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/mobile/2_intro/image_2.png',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/mobile/2_intro/image_3.png',
                    },
                    {
                        alias: 'UnifrakturCook',
                        src: 'assets/mobile/11_font/ttf_unifrakturCook/UnifrakturCook.ttf',
                    },
                    {
                        alias: 'ticketBaseSkel',
                        src: 'assets/mobile/2_intro/ticket.skel',
                    },
                    {
                        alias: 'ticketBaseAtlas',
                        src: 'assets/mobile/2_intro/ticket.atlas',
                    },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/9_bigwin/es/spanish_wins.skel' : 'assets/mobile/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/9_bigwin/es/spanish_wins.atlas' : 'assets/mobile/9_bigwin/wins.atlas',
                    },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'character_cloud',
                        src: 'assets/mobile/5_character/character_cloud.webp',
                    },
                    {
                        alias: 'background',
                        src: 'assets/mobile/6_basegame/basegame_static.webp',
                    },
                    // reels back
                    {
                        alias: 'reelBackSkel',
                        src: 'assets/mobile/10_reel/reel.skel',
                    },
                    {
                        alias: 'reelBackAtlas',
                        src: 'assets/mobile/10_reel/reel.atlas',
                    },
                    //Feature Trigger Indicators
                    // 1. ZEUS
                    {
                        alias: 'lightTriggerIndicatorSkel',
                        src: 'assets/mobile/14_feature/triggering_features/blue/blue_special.skel',
                    },
                    {
                        alias: 'lightTriggerIndicatorAtlas',
                        src: 'assets/mobile/14_feature/triggering_features/blue/blue_special.atlas',
                    },
                    // 2. POSEIDON
                    {
                        alias: 'oceanTriggerIndicatorSkel',
                        src: 'assets/mobile/14_feature/triggering_features/green/green_ball.skel',
                    },
                    {
                        alias: 'oceanTriggerIndicatorAtlas',
                        src: 'assets/mobile/14_feature/triggering_features/green/green_ball.atlas',
                    },
                    // 3. HADES
                    {
                        alias: 'infernoTriggerIndicatorSkel',
                        src: 'assets/mobile/14_feature/triggering_features/red/red_special.skel',
                    },
                    {
                        alias: 'infernoTriggerIndicatorAtlas',
                        src: 'assets/mobile/14_feature/triggering_features/red/red_special.atlas',
                    },
                    // Side Meters 
                    // Win frames Anticipation
                    {
                        alias: 'symbolAnticipationSkel',
                        src: 'assets/mobile/14_feature/symbol_anticipation/win_frame.skel',
                    },
                    {
                        alias: 'symbolAnticipationAtlas',
                        src: 'assets/mobile/14_feature/symbol_anticipation/win_frame.atlas',
                    },
                    //Double Effect
                    {
                        alias: 'doubleEffectSkel',
                        src: 'assets/mobile/14_feature/double_effect/skull_impact.skel',
                    },
                    {
                        alias: 'doubleEffectAtlas',
                        src: 'assets/mobile/14_feature/double_effect/skull_impact.atlas',
                    },
                    //Max win
                    {
                        alias: 'maxWinMeterSkel',
                        src: 'assets/mobile/8_freegame/meters/max_win/max_win.skel',
                    },
                    {
                        alias: 'maxWinMeterAtlas',
                        src: 'assets/mobile/8_freegame/meters/max_win/max_win.atlas',
                    },
                    // Mega win
                    {
                        alias: 'megaWinMeterSkel',
                        src: 'assets/mobile/8_freegame/meters/mega/mega.skel',
                    },
                    {
                        alias: 'megaWinMeterAtlas',
                        src: 'assets/mobile/8_freegame/meters/mega/mega.atlas',
                    },
                    //Major win
                    {
                        alias: 'majorWinMeterSkel',
                        src: 'assets/mobile/8_freegame/meters/major/major.skel',
                    },
                    {
                        alias: 'majorWinMeterAtlas',
                        src: 'assets/mobile/8_freegame/meters/major/major.atlas',
                    },
                    //Mini win
                    {
                        alias: 'miniWinMeterSkel',
                        src: 'assets/mobile/8_freegame/meters/mini/mini.skel',
                    },
                    {
                        alias: 'miniWinMeterAtlas',
                        src: 'assets/mobile/8_freegame/meters/mini/mini.atlas',
                    },
                    // character animation *********************
                    {
                        alias: 'lightCharacterSkel',
                        src: 'assets/mobile/5_character/mascot_1/mascot_1.skel',
                    },
                    {
                        alias: 'lightCharacterAtlas',
                        src: 'assets/mobile/5_character/mascot_1/mascot_1.atlas',
                    },
                    {
                        alias: 'oceanCharacterSkel',
                        src: 'assets/mobile/5_character/mascot_2/mascot_2.skel',
                    },
                    {
                        alias: 'oceanCharacterAtlas',
                        src: 'assets/mobile/5_character/mascot_2/mascot_2.atlas',
                    },
                    {
                        alias: 'infernCharacterSkel',
                        src: 'assets/mobile/5_character/mascot_3/mascot_3.skel',
                    },
                    {
                        alias: 'infernCharacterAtlas',
                        src: 'assets/mobile/5_character/mascot_3/mascot_3.atlas',
                    },
                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/mobile/3_game_intro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/mobile/3_game_intro/game_intro.atlas',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/mobile/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/mobile/4_logo/logo.atlas',
                    },
                    //banner-spine
                    {
                        alias: 'bannerOutroStatic',
                        src: 'assets/mobile/7_banner/banner_outro_static.webp',
                    },
                    // Intro outro banner spine
                    {
                        alias: 'bannerPotSkel',
                        src: 'assets/mobile/7_banner/intro_outro.skel',
                    },
                    {
                        alias: 'bannerPotAtlas',
                        src: 'assets/mobile/7_banner/intro_outro.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/mobile/6_basegame/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/mobile/6_basegame/basegame.atlas',
                    },
                    //free game transition
                    {
                        alias: 'transitionSkel',
                        src: 'assets/mobile/8_freegame/transition/bg_to_bonus_transition.skel',
                    },
                    {
                        alias: 'transitionAtlas',
                        src: 'assets/mobile/8_freegame/transition/bg_to_bonus_transition.atlas',
                    },
                    //spin left meter
                    {
                        alias: 'spinLeftSkel',
                        src: 'assets/mobile/14_feature/spinMeter/meter.skel',
                    },
                    {
                        alias: 'spinLeftAtlas',
                        src: 'assets/mobile/14_feature/spinMeter/meter.atlas',
                    },

                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/mobile/12_symbols/hv_1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/mobile/12_symbols/hv_1/hv_1.atlas',
                    },
                    {
                        alias: 'hv1Static',
                        src: 'assets/mobile/12_symbols/hv_1/hv1Static.webp',
                    },
                    {
                        alias: 'hv1Blur',
                        src: 'assets/mobile/12_symbols/hv_1/hv1Blur.webp',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/mobile/12_symbols/hv_2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/mobile/12_symbols/hv_2/hv_2.atlas',
                    },
                    {
                        alias: 'hv2Static',
                        src: 'assets/mobile/12_symbols/hv_2/hv2Static.webp',
                    },
                    {
                        alias: 'hv2Blur',
                        src: 'assets/mobile/12_symbols/hv_2/hv2Blur.webp',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/mobile/12_symbols/hv_3/hv3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/mobile/12_symbols/hv_3/hv3.atlas',
                    },
                    {
                        alias: 'hv3Static',
                        src: 'assets/mobile/12_symbols/hv_3/hv3Static.webp',
                    },
                    {
                        alias: 'hv3Blur',
                        src: 'assets/mobile/12_symbols/hv_3/hv3Blur.webp',
                    },
                    //mv1
                    {
                        alias: 'hv4Skel',
                        src: 'assets/mobile/12_symbols/hv_4/hv4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/mobile/12_symbols/hv_4/hv4.atlas',
                    },
                    {
                        alias: 'hv4Static',
                        src: 'assets/mobile/12_symbols/hv_4/hv4Static.webp',
                    },
                    {
                        alias: 'hv4Blur',
                        src: 'assets/mobile/12_symbols/hv_4/hv4Blur.webp',
                    },
                    //mv2
                    {
                        alias: 'hv5Skel',
                        src: 'assets/mobile/12_symbols/hv_5/hv5.skel',
                    },
                    {
                        alias: 'hv5Atlas',
                        src: 'assets/mobile/12_symbols/hv_5/hv5.atlas',
                    },
                    {
                        alias: 'hv5Static',
                        src: 'assets/mobile/12_symbols/hv_5/hv5Static.webp',
                    },
                    {
                        alias: 'hv5Blur',
                        src: 'assets/mobile/12_symbols/hv_5/hv5Blur.webp',
                    },
                    // //mv3
                    // {
                    //     alias: 'hv6Skel',
                    //     src: 'assets/mobile/12_symbols/hv_6/hv_6.skel',
                    // },
                    // {
                    //     alias: 'hv6Atlas',
                    //     src: 'assets/mobile/12_symbols/hv_6/hv_6.atlas',
                    // },
                    // {
                    //     alias: 'hv6Static',
                    //     src: 'assets/mobile/12_symbols/hv_6/hv6Static.webp',
                    // },
                    // {
                    //     alias: 'hv6Blur',
                    //     src: 'assets/mobile/12_symbols/hv_6/hv6Blur.webp',
                    // },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/mobile/12_symbols/lv_1/lv1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/mobile/12_symbols/lv_1/lv1.atlas',
                    },
                    {
                        alias: 'lv1Static',
                        src: 'assets/mobile/12_symbols/lv_1/lv1Static.webp',
                    },
                    {
                        alias: 'lv1Blur',
                        src: 'assets/mobile/12_symbols/lv_1/lv1Blur.webp',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/mobile/12_symbols/lv_2/lv2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/mobile/12_symbols/lv_2/lv2.atlas',
                    },
                    {
                        alias: 'lv2Static',
                        src: 'assets/mobile/12_symbols/lv_2/lv2Static.webp',
                    },
                    {
                        alias: 'lv2Blur',
                        src: 'assets/mobile/12_symbols/lv_2/lv2Blur.webp',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/mobile/12_symbols/lv_3/lv3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/mobile/12_symbols/lv_3/lv3.atlas',
                    },
                    {
                        alias: 'lv3Static',
                        src: 'assets/mobile/12_symbols/lv_3/lv3Static.webp',
                    },
                    {
                        alias: 'lv3Blur',
                        src: 'assets/mobile/12_symbols/lv_3/lv3Blur.webp',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/mobile/12_symbols/lv_4/lv4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/mobile/12_symbols/lv_4/lv4.atlas',
                    },
                    {
                        alias: 'lv4Static',
                        src: 'assets/mobile/12_symbols/lv_4/lv4Static.webp',
                    },
                    {
                        alias: 'lv4Blur',
                        src: 'assets/mobile/12_symbols/lv_4/lv4Blur.webp',
                    },
                    //lv5
                    {
                        alias: 'lv5Skel',
                        src: 'assets/mobile/12_symbols/lv_5/lv5.skel',
                    },
                    {
                        alias: 'lv5Atlas',
                        src: 'assets/mobile/12_symbols/lv_5/lv5.atlas',
                    },
                    {
                        alias: 'lv5Static',
                        src: 'assets/mobile/12_symbols/lv_5/lv5Static.webp',
                    },
                    {
                        alias: 'lv5Blur',
                        src: 'assets/mobile/12_symbols/lv_5/lv5Blur.webp',
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/mobile/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/mobile/12_symbols/wild/wild.atlas',
                    },
                    {
                        alias: 'wildStatic',
                        src: 'assets/mobile/12_symbols/wild/wildStatic.webp',
                    },
                    {
                        alias: 'wildBlur',
                        src: 'assets/mobile/12_symbols/wild/wildBlur.webp',
                    },
                    //Gold coin
                    {
                        alias: 'goldCoinSkel',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coin.skel',
                    },
                    {
                        alias: 'goldCoinAtlas',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coin.atlas',
                    },
                    {
                        alias: 'goldCoinStatic',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coinStatic.png',
                    },
                    {
                        alias: 'goldCoinBlur',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coinBlur.webp',
                    },
                    //Special symbol - Zeus
                    {
                        alias: 'spSymbolZeusSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_1/special_symbol_1.skel',
                    },
                    {
                        alias: 'spSymbolZeusAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_1/special_symbol_1.atlas',
                    },
                    {
                        alias: 'spSymbolZeusStatic',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_1/special_symbol_1Static.webp',
                    },
                    {
                        alias: 'spSymbolZeusBlur',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_1/special_symbol_1Blur.webp',
                    },
                    //Special symbol - Poseidon
                    {
                        alias: 'spSymbolPoseidonSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_2/special_symbol_2.skel',
                    },
                    {
                        alias: 'spSymbolPoseidonAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_2/special_symbol_2.atlas',
                    },
                    {
                        alias: 'spSymbolPoseidonStatic',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_2/special_symbol_2Static.webp',
                    },
                    {
                        alias: 'spSymbolPoseidonBlur',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_2/special_symbol_2Blur.webp',
                    },
                    //Special symbol - Hades
                    {
                        alias: 'spSymbolHadesSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_3/special_symbol_3.skel',
                    },
                    {
                        alias: 'spSymbolHadesAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_3/special_symbol_3.atlas',
                    },
                    {
                        alias: 'spSymbolHadesStatic',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_3/special_symbol_3Static.webp',
                    },
                    {
                        alias: 'spSymbolHadesBlur',
                        src: 'assets/mobile/12_symbols/special_symbols/special_symbol_3/special_symbol_3Blur.webp',
                    },
                    {
                        alias: 'blankSymbol',
                        src: 'assets/mobile/12_symbols/blank/blank_coin.png',
                    },
                    //Collector Zeus
                    {
                        alias: 'collectorZeusSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_lightning_strike_symbol/sticky_lightning_strike_symbol.skel',
                    },
                    {
                        alias: 'collectorZeusAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_lightning_strike_symbol/sticky_lightning_strike_symbol.atlas',
                    },
                    //Doubler Hades
                    {
                        alias: 'doublerHadesSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_inferno_double_symbol/sticky_inferno_double_symbol.skel',
                    },
                    {
                        alias: 'doublerHadesAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_inferno_double_symbol/sticky_inferno_double_symbol.atlas',
                    },
                    //Adder Poseidon
                    {
                        alias: 'adderPoseidonSkel',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_ocean_collect_symbol/sticky_ocean_collect_symbol.skel',
                    },
                    {
                        alias: 'adderPoseidonAtlas',
                        src: 'assets/mobile/12_symbols/special_symbols/sticky_ocean_collect_symbol/sticky_ocean_collect_symbol.atlas',
                    },
                    // Trail Animations for above special symbols
                    {
                        alias: 'spGreenTrailSkel',
                        src: 'assets/mobile/17_trails/green/green_trail.skel',
                    },
                    {
                        alias: 'spGreenTrailAtlas',
                        src: 'assets/mobile/17_trails/green/green_trail.atlas',
                    },
                    {
                        alias: 'spBlueTrailSkel',
                        src: 'assets/mobile/17_trails/blue/blue_trail.skel',
                    },
                    {
                        alias: 'spBlueTrailAtlas',
                        src: 'assets/mobile/17_trails/blue/blue_trail.atlas',
                    },
                    {
                        alias: 'spPinkTrailSkel',
                        src: 'assets/mobile/17_trails/red/red_trail.skel',
                    },
                    {
                        alias: 'spPinkTrailAtlas',
                        src: 'assets/mobile/17_trails/red/red_trail.atlas',
                    },
                    // Thunder trail
                    {
                        alias: 'thunderTrailSkel',
                        src: 'assets/mobile/17_trails/random_effect.skel',
                    },
                    {
                        alias: 'thunderTrailAtlas',
                        src: 'assets/mobile/17_trails/random_effect.atlas',
                    },
                    // Transitions
                    {
                        alias: 'bannerTransitionSkel',
                        src: 'assets/mobile/18_transitions/transition.skel',
                    },
                    {
                        alias: 'bannerTransitionAtlas',
                        src: 'assets/mobile/18_transitions/transition.atlas',
                    },
                    // Collection Pannel  to collect the winning symbols
                    {
                        alias: 'collectionPannelSkel',
                        src: 'assets/mobile/14_feature/winMeter/digital_pannel.skel',
                    },
                    {
                        alias: 'collectionPannelAtlas',
                        src: 'assets/mobile/14_feature/winMeter/digital_pannel.atlas',
                    },

                    // a transition after all spins and before win collection 
                    {
                        alias: 'bonusCollectTransitionSkel',
                        src: 'assets/mobile/14_feature/bonus_collect_transition/bonus_collect_transition.skel',
                    },
                    {
                        alias: 'bonusCollectTransitionAtlas',
                        src: 'assets/mobile/14_feature/bonus_collect_transition/bonus_collect_transition.atlas',
                    },

                    // a asteroid animation when multiplier appear on a coin 
                    {
                        alias: 'bonusCoinTrailSkel',
                        src: 'assets/mobile/14_feature/multiplier_trail/bonus_coin_trail.skel',
                    },
                    {
                        alias: 'bonusCoinTrailAtlas',
                        src: 'assets/mobile/14_feature/multiplier_trail/bonus_coin_trail.atlas',
                    },
                    // paylines animation
                    {
                        alias: 'winLineSkel',
                        src: 'assets/mobile/16_paylines/payline.skel',
                    },
                    {
                        alias: 'winLineAtlas',
                        src: 'assets/mobile/16_paylines/payline.atlas',
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/mobile/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/mobile/12_symbols/wild/wild.atlas',
                    },
                    //  3 God's Fonts
                    {
                        alias: 'Adonais',
                        src: 'assets/mobile/11_font/Adonais.ttf',
                    },
                    {
                        alias: '3God_coin',
                        src: 'assets/mobile/11_font/3god/3god.xml',
                    },
                    {
                        alias: '3God_banner_font',
                        src: 'assets/mobile/11_font/3god/banner_font.xml',
                    },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/mobile/13_sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/mobile/13_sound/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        src: 'assets/mobile/13_sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'lightning_strike',
                        src: 'assets/mobile/13_sound/base/lightning_strike.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/mobile/13_sound/base/Bg_loop.mp3',
                    },
                    // {
                    //     alias: 'witch_symbol_flip',
                    //     src: 'assets/mobile/13_sound/base/witch_symbol_coin_flip.mp3',
                    // },
                    {
                        alias: 'god_symbol_flip',
                        src: 'assets/mobile/13_sound/base/god_symbol_flip.mp3',
                    },
                    {
                        alias: 'god_symbol_firing',
                        src: 'assets/mobile/13_sound/base/god_symbol_firing.mp3',
                    },                    // {
                    //     alias: 'wolf_character_movinghandacross_knife',
                    //     src: 'assets/mobile/13_sound/base/wolf_character_movinghandacross_knife.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation3_licking',
                    //     src: 'assets/mobile/13_sound/base/wolf_character_animation3_licking.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation4_redeyes',
                    //     src: 'assets/mobile/13_sound/base/wolf_character_animation4_redeyes.mp3',
                    // },
                    // {
                    //     alias: 'wolf_character_animation5_flicksknife',
                    //     src: 'assets/mobile/13_sound/base/wolf_character_animation5_flicksknife.mp3',
                    // },
                    // {
                    //     alias: 'bonus_meter_filled',
                    //     src: 'assets/mobile/13_sound/freegame/bonus_meter_filled.mp3',
                    // },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/mobile/13_sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/mobile/13_sound/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'free_Game_outro_Banner',
                        src: 'assets/mobile/13_sound/freegame/free_game_explosion.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/mobile/13_sound/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'transition_before_win_collect',
                        src: 'assets/mobile/13_sound/freegame/3bats_transition.mp3',
                    },
                    {
                        alias: 'extra_spin_awarded',
                        src: 'assets/mobile/13_sound/freegame/bluebat_drop.mp3',
                    },
                    {
                        alias: 'coin_appear_sound',
                        src: 'assets/mobile/13_sound/freegame/mmmm_symbol.mp3',
                    },
                    {
                        alias: 'spin_meter_refill',
                        src: 'assets/mobile/13_sound/freegame/fspins_panel.mp3',
                    },
                    {
                        alias: '3_last_slots',
                        src: 'assets/mobile/13_sound/freegame/3_last_slots.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/mobile/13_sound/freegame/total_win.mp3',
                    },
                    {
                        alias: 'total_win_end',
                        src: 'assets/mobile/13_sound/freegame/total_win_end.mp3',
                    },
                    {
                        alias: 'multiplier_collect',
                        src: 'assets/mobile/13_sound/freegame/multiplier_collect.mp3',
                    },
                    // {
                    //     alias: 'spin_meter_fill_sound',
                    //     src: 'assets/mobile/13_sound/freegame/mmmm_symbol.mp3',
                    // },
                    {
                        alias: 'jackpot_symbol_flip',
                        src: 'assets/mobile/13_sound/freegame/symbol_spinning.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/mobile/13_sound/gameloading/Intro_transition.mp3',
                    },
                    {
                        alias: 'thunder_transition',
                        src: 'assets/mobile/13_sound/gameloading/thunder_transition.mp3',
                    },
                    {
                        alias: 'reel_stop',
                        src: 'assets/mobile/13_sound/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'reels_spinning',
                        src: 'assets/mobile/13_sound/spin/reels_spinning.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/mobile/13_sound/win/common_win.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/mobile/13_sound/win/Win_With_Multiplier.mp3',
                    },
                    {
                        alias: 'wild_sound_effect',
                        src: 'assets/mobile/13_sound/win/wild.mp3',
                    },
                    {
                        alias: 'win_loop',
                        src: 'assets/mobile/13_sound/bigwin/Win_Loop.mp3',
                    },
                    // fight sequence sound effects
                    // {
                    //     alias: 'lady_killing_the_wolf_gunshot',
                    //     src: 'assets/mobile/13_sound/fight/lady_killing_the_wolf_gunshot.mp3',
                    // },
                    // {
                    //     alias: 'lady_killing_the_wolf_shout_effect',
                    //     src: 'assets/mobile/13_sound/fight/lady_killing_the_wolf_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'man_killing_the_wolf_gunshot',
                    //     src: 'assets/mobile/13_sound/fight/man_killing_the_wolf_gunshot.mp3',
                    // },
                    // {
                    //     alias: 'man_killing_the_wolf_shout_effect',
                    //     src: 'assets/mobile/13_sound/fight/man_killing_the_wolf_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_man_lady_effect',
                    //     src: 'assets/mobile/13_sound/fight/wolf_killing_man_lady_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_the_lady_shout_effect',
                    //     src: 'assets/mobile/13_sound/fight/wolf_killing_the_lady_shout_effect.mp3',
                    // },
                    // {
                    //     alias: 'wolf_killing_the_man_shout_effect',
                    //     src: 'assets/mobile/13_sound/fight/wolf_killing_the_man_shout_effect.mp3',
                    // },
                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/mobile/13_sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/mobile/13_sound/bigwin/Win_Count_up_End.mp3',
                    },
                    //character sounds
                    {
                        alias: 'hades',
                        src: 'assets/mobile/13_sound/character/hades.mp3',
                    },
                    {
                        alias: 'inferno_double',
                        src: 'assets/mobile/13_sound/character/inferno_double.mp3',
                    },
                    {
                        alias: 'zeus',
                        src: 'assets/mobile/13_sound/character/zeus.mp3',
                    },
                    {
                        alias: 'ocean',
                        src: 'assets/mobile/13_sound/character/ocean.mp3',
                    },
                    // multiplier_hit
                    {
                        alias: 'multiplier_hit',
                        src: 'assets/mobile/13_sound/freegame/flame_multiplier_drop.mp3',
                    },
                    {
                        alias: 'final_count_increasing',
                        src: 'assets/mobile/13_sound/freegame/final_count_increasing.mp3',
                    },
                    {
                        alias: 'inferno_double_doubling_multipliers',
                        src: 'assets/mobile/13_sound/freegame/inferno_double_doubling_multipliers.mp3',
                    },
                    {
                        alias: 'ocean_multipliers_flying_to_be_collected',
                        src: 'assets/mobile/13_sound/freegame/ocean_multipliers_flying_to_be_collected.mp3',
                    },
                    {
                        alias: 'lightning_strike_increasing_multipliers',
                        src: 'assets/mobile/13_sound/freegame/lightning_strike_increasing_multipliers.mp3',
                    },
                    // Max win reel anticipation
                    {
                        alias: 'maxwin_anticipation_start',
                        src: 'assets/mobile/13_sound/freegame/grid_on_fire_start.mp3',
                    },
                    {
                        alias: 'maxwin_anticipation_loop',
                        src: 'assets/mobile/13_sound/freegame/grid_on_fire_loop.mp3',
                    },
                ],
            },

        ],
    }
};

